import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    color: palette.common.white,
    height: '32px',
    fontSize: '13px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    flexShrink: '0',
    lineHeight: '32px',
    marginRight: '-10px',
    textAlign: 'center',
    width: '32px'
  },
  avatarsBlock: {
    alignItems: 'center',
    // display: 'flex',
    marginLeft: '12px',
    display: 'inline-flex',
    marginRight: '16px'
  },
  containerDefault: {
    maxWidth: '100%',
    paddingBottom: "".concat(CONSTANTS.PAGE_BOTTOM_PADDING, "px"),
    flexGrow: '1'
  },
  containerSmall: {
    paddingBottom: '20px'
  },
  searchBar: {
    padding: '20px 24px',
    boxShadow: palette.shadows.light,
    background: palette.shades[200],
    display: 'flex',
    borderRadius: '2px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  searchField: {
    flexGrow: '1',
    marginRight: '10px',
    maxWidth: '400px',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginRight: '0',
      marginBottom: '18px'
    }
  },
  tableTitle: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 24px'
  },
  tableTitleBlock: {
    display: 'flex',
    maxWidth: '45%'
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column'
  },
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0% 20%',
    height: '100%',
    width: '100%',
    marginTop: '20%',
    justifyContent: 'center'
  },
  emptyStateContainerItem: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center'
  },
  emptyStateContainerItemAddPropertyButton: {
    width: '50%',
    marginLeft: '25%'
  }
}));
export default useStyles;